<template>
  <teleport to="body">
    <!-- The v-if directive controls the modal's visibility -->
    <!-- ****** THIS IS THE FIX ****** -->
    <!-- `bg-black/60` makes the background black with 60% opacity. -->
    <!-- `backdrop-blur-sm` adds a subtle "frosted glass" effect to the content behind the modal. -->
    <div v-if="show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-xl p-8 text-center flex flex-col items-center">
        <!-- A nice SVG spinner -->
        <svg class="animate-spin h-12 w-12 text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V4a10 10 0 00-10 10h2zm0 0a8 8 0 018 8v-2a6 6 0 00-6-6H4z"></path>
        </svg>

        <!-- The customizable message -->
        <p class="text-lg font-medium text-gray-700">{{ message }}</p>
      </div>
    </div>
  </teleport>
</template>

<script setup>
// The script remains unchanged. This is a purely visual update.
defineProps({
  show: {
    type: Boolean,
    required: true
  },
  message: {
    type: String,
    default: 'Processing...'
  }
})
</script>
